<template>
    <div>
        <template v-if="marcacao.paciente && marcacao.paciente.cadastro && marcacao.paciente.paciente_unidade">
            <div class="alert alert-info">
                Para alteração dos dados cadastrais (nome, e-mail, operadora/plano e CPF), favor entrar em contato com a nossa Central de Atendimento.
            </div>

            <div class="row">
                <div class="col col-12 col-md-6">
                    <az-input
                        sizing="sm"
                        label="Nome"
                        :edicao="false"
                        v-model="marcacao.paciente.st_nome" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input
                        sizing="sm"
                        label="Nome Social"
                        :edicao="true"
                        v-model="marcacao.paciente.st_nome_social" />
                </div>

                <div class="col col-12 col-md-3">
                    <az-input
                        sizing="sm"
                        label="Nome da Mãe"
                        :edicao="true"
                        v-model="marcacao.paciente.cadastro.st_nome_mae" />
                </div>
            </div>

            <div class="row">
                <div class="col col-12 col-md-6">
                    <az-input
                        sizing="sm"
                        label="e-mail"
                        :edicao="false"
                        v-model="marcacao.paciente.cadastro.st_email" />
                </div>

                <div class="col col-12 col-md-3">
                    <az-input
                        sizing="sm"
                        label="Telefone"
                        type="fone"
                        :edicao="true"
                        v-model="marcacao.paciente.cadastro.telefones.telefone" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input
                        sizing="sm"
                        label="Celular"
                        type="fone"
                        :edicao="true"
                        v-model="marcacao.paciente.cadastro.telefones.celular" />
                </div>
            </div>

            <div class="row">
                <div class="col col-12 col-md-6">
                    <az-input
                        sizing="sm"
                        label="Operadora/Plano"
                        :edicao="false"
                        v-model="marcacao.paciente.paciente_unidade.plano.search" />
                </div>

                <div class="col col-12 col-md-3">
                    <az-input
                        sizing="sm"
                        label="CPF"
                        type="cpf"
                        :edicao="false"
                        v-model="marcacao.paciente.cadastro.st_cpf" />
                </div>

                <div class="col col-12 col-md-3">
                    <az-input
                        sizing="sm"
                        label="RG"
                        :edicao="true"
                        v-model="marcacao.paciente.cadastro.st_rg" />
                </div>
            </div>

            <div class="row" v-if="marcacao.paciente.paciente_unidade.plano.id_operadora != 1">
                <div class="col col-6">
                    <az-input
                        sizing="sm"
                        label="Número da Carteira do Plano"
                        :edicao="true"
                        v-model="marcacao.paciente.paciente_unidade.st_numero_carteira" />
                </div>

                <div class="col col-6">
                    <az-input
                        type="date"
                        sizing="sm"
                        label="Validade da Carteira do Plano"
                        :edicao="true"
                        v-model="marcacao.paciente.paciente_unidade.dt_validade_carteira" />
                </div>
            </div>
        </template>
        
        <cadastro-endereco 
            v-if="marcacao.paciente.cadastro && marcacao.paciente.cadastro.endereco"
            sizing="sm"
            :portal="true" 
            :simples="true" 
            :edicao="true"
            :marcacao="marcacao" 
            :dominio="domain" 
            :token="token"
            v-model="marcacao.paciente.cadastro.endereco" />
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../shared/forms/AzInput.vue';
import CadastroEndereco from '../../components/shared/CadastroEndereco.vue';

export default {
    data() { 
        return { 
            dados: null, 
            finalizado: false, 
            validate: false, 
        }
    },

    props: ['marcacao', 'domain', 'token', 'action'],

    components: { 
        AzInput,
        CadastroEndereco, 
    },

    computed: { 
        is_chapp: function () { 
            return ( this.marcacao && this.marcacao.plano && this.marcacao.plano.search 
                && this.marcacao.plano.search.substr(0,5).toUpperCase() == 'CHAPP' );
        }
    },
    
    methods: { 

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'pacientes', 
                func: 'atualizar_cadastro_portal',
                dados: this.marcacao.paciente,
                modal: 'meusDadosModal',
                toast: true, 
            });
        }

    },

    mounted() { 
        if ( !this.paciente && this.marcacao.cadastro_temporario ) { 

            this.marcacao.cadastro_temporario.dt_nascimento = this.marcacao.cadastro_temporario.dt_nascimento.substr(0,10);
            this.marcacao.cadastro_temporario.dt_nasc_mobile = '21/02/1978';
            
            /*new Date(this.marcacao.cadastro_temporario.dt_nascimento)
                .toISOString()
                .split("T")[0];*/

            //console.log(this.marcacao.cadastro_temporario.dt_nasc_mobile);

            if ( !this.marcacao.cadastro_temporario.endereco ) { 
                this.marcacao.cadastro_temporario.endereco = { 
                    cidade: {}
                };
            }

            if ( !this.marcacao.cadastro_temporario.st_cpf ) { 
                this.$nextTick(() => { 
                    if ( ( !this.action || this.action == 'cn' ) && ( !this.is_chapp ) ) { 
                        $('#collapseCadastro').collapse('show');
                    }
                });
            }

        }

        this.dados = this.marcacao;
    }
}
</script>